import { defineComponent as _defineComponent } from 'vue'
import Modal from "../Modal.vue";
  import { computed } from "vue";
  import store from "@/store";
  import plural from "@/features/plural";
  import { UserQuoteSelectionInterface } from "@/types/UserQuoteSelectionInterface";
  import { POSITION, useToast } from "vue-toastification";
  import HouseSelectionsCard from "@/components/builder/HouseSelectionsCard.vue";
  import { SelectionStepsIndexEnum } from "@/enums/BuilderStepsIndex";
  import { CustomizeHouseStepsEnum } from "@/enums/CustomizeHouseSteps";
  import { LotActionInterface } from "@/types/LotActionInterface";

  interface Props {
    isOpen: boolean;
    lot: LotActionInterface;
  }

  
export default /*@__PURE__*/_defineComponent({
  __name: 'BuilderQuotesListsModal',
  props: {
    isOpen: { type: Boolean },
    lot: {}
  },
  emits: [
    "close",
    "addQuote",
    "updateQuote",
    "deleteQuote",
    "toRequestQuoteForm",
  ],
  setup(__props: any, { expose: __expose, emit: __emit }) {
  __expose();

  const props = __props;

  const emits = __emit;

  const toast = useToast();
  const selectedQuote = computed(
    () => store.getters["builder/getSelectedSelection"]
  );

  const onClose = () => {
    emits("close");
  };

  const userSelections = computed(() => {
    return store.state.builder.userSelectionDesign;
  });

  const requestQuoteCounter = computed(() => {
    return store.state.builder.userSelectionDesign.length;
  });

  const checkCanAdd = () => {
    const hasIncompleteQuotes = userSelections.value.some(
      (selection) =>
        selection.currentStep !== CustomizeHouseStepsEnum.CONFIRMATION
    );

    return !hasIncompleteQuotes;
  };

  const onGetMoreQuotes = () => {
    if (!checkCanAdd()) {
      toast.error(
        "Please complete step 4 before adding any additional quotes",
        {
          position: POSITION.TOP_LEFT,
        }
      );
      return;
    }

    emits("addQuote");
  };

  const onUpdateUserSelection = (selectionId: number) => {
    emits("updateQuote", selectionId);
  };

  const onDeleteUserSelection = (selectionId: number) => {
    if (store.state.builder.userSelectionDesign.length === 1) {
      toast.error("You must have at least one quote.");
      return;
    }

    emits("deleteQuote", selectionId);
  };
  const checkStoreHasValues = () =>
    store.getters["builder/hasUserSelectionDesignEmptyValues"];
  const submit = () => {
    if (checkStoreHasValues()) {
      toast.error(
        "Please ensure that all selections are filled in your quotes"
      );
      return;
    }

    onClose();
    emits("toRequestQuoteForm");
  };

const __returned__ = { props, emits, toast, selectedQuote, onClose, userSelections, requestQuoteCounter, checkCanAdd, onGetMoreQuotes, onUpdateUserSelection, onDeleteUserSelection, checkStoreHasValues, submit, Modal, computed, get store() { return store }, get plural() { return plural }, get UserQuoteSelectionInterface() { return UserQuoteSelectionInterface }, get POSITION() { return POSITION }, get useToast() { return useToast }, HouseSelectionsCard, get SelectionStepsIndexEnum() { return SelectionStepsIndexEnum }, get CustomizeHouseStepsEnum() { return CustomizeHouseStepsEnum }, get LotActionInterface() { return LotActionInterface } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})